import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class WrongVatRateUsedOnDocumentError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.items.vat-rate.wrong-vat-rate-used-on-document');
    }
}
